module.exports = __webpack_public_path__ + "img/no-results.04a26be7.png";